var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "bar" }, [
      _c("div", { class: _vm.$style.title }, [
        _c(
          "i",
          { staticClass: "material-icons", class: _vm.$style.titleIcon },
          [_vm._v("local_airport")]
        ),
        _c("div", [
          _c("div", { class: _vm.$style.titleText }, [_vm._v("Travel Policy")]),
          _c("div", { class: _vm.$style.titleSubText }, [
            _vm._v(
              "Upload your travel policy to make it available for your users to download"
            ),
          ]),
        ]),
      ]),
    ]),
    _vm.loaded
      ? _c(
          "div",
          { class: _vm.$style.main },
          [
            _c("input", {
              ref: "fileSelector",
              class: _vm.$style.hide,
              attrs: { type: "file", accept: "application/pdf" },
              on: { change: _vm.upload },
            }),
            _vm.uploading
              ? _c("rbv-loading", {
                  attrs: { label: `Uploading File (${_vm.uploadProgress}%)` },
                })
              : _vm.hasTravelPolicy
              ? [
                  _c("div", { class: _vm.$style.name }, [
                    _vm._v(_vm._s(_vm.filename)),
                  ]),
                  _c("i", {
                    staticClass: "fa fa-file-pdf-o",
                    class: _vm.$style.uploadedIcon,
                  }),
                  _c("div", { class: _vm.$style.text }, [
                    _vm._v(
                      " You can only upload files in .PDF format. if your file is in another format, you can convert it , or save it as a .pdf in your text editor. "
                    ),
                  ]),
                  _c("div", { class: _vm.$style.buttons }, [
                    _c("div", [
                      _c(
                        "a",
                        {
                          staticClass: "button",
                          attrs: {
                            href: _vm.directory.travelPolicy,
                            target: "_self",
                            download: "travel_policy",
                          },
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("get_app"),
                          ]),
                          _vm._v(" Download "),
                        ]
                      ),
                    ]),
                    _c(
                      "button",
                      { staticClass: "button", on: { click: _vm.drop } },
                      [_vm._v(" Delete ")]
                    ),
                    _c(
                      "button",
                      { staticClass: "button cta", on: { click: _vm.select } },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("publish"),
                        ]),
                        _vm._v(" Upload New "),
                      ]
                    ),
                  ]),
                ]
              : [
                  _c("div", { class: _vm.$style.name }, [
                    _vm._v("Upload Your Travel Policy"),
                  ]),
                  _c("i", {
                    staticClass: "fa fa-file-pdf-o",
                    class: _vm.$style.icon,
                  }),
                  _c("div", { class: _vm.$style.text }, [
                    _vm._v(
                      " You can only upload files in .PDF format. if your file is in another format, you can convert it , or save it as a .pdf in your text editor. "
                    ),
                  ]),
                  _c("div", { class: _vm.$style.buttons }, [
                    _c("div", [
                      _c(
                        "a",
                        {
                          staticClass: "button",
                          attrs: {
                            href: "/files/sample_hotel_directory_travel_policy.docx",
                            target: "_self",
                            download: "sample_travel_policy",
                          },
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("get_app"),
                          ]),
                          _vm._v(" Download Sample "),
                        ]
                      ),
                    ]),
                    _c(
                      "button",
                      { staticClass: "button cta", on: { click: _vm.select } },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("publish"),
                        ]),
                        _vm._v(" Upload File "),
                      ]
                    ),
                  ]),
                ],
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }